import axios from "axios"
import decode from "jwt-decode"

const STAGE_DOMAIN = 'https://stage-lms.alive.university'

export const isProd = true
export const stage = false

export const baseURL = isProd ? 'https://alive-core-api.alive.university/api/v2' : stage ? `${STAGE_DOMAIN}/api/v2/core` : 'http://localhost:5500/api/v2'
export const meetingsBaseURL = isProd ? 'https://alive-core-api.alive.university/api/v2' : stage ? `${STAGE_DOMAIN}/api/v2/core` : 'http://localhost:5500/api/v2'
export const studyMaterialBaseURL = isProd ? 'https://studymaterial-api.alive.university/api/v2' : stage ? `${STAGE_DOMAIN}/api/v2/studymaterial` : 'http://localhost:5600/api/v2'
export const examBaseURL = isProd ? `https://exam-api.alive.university/api/v2` : stage ? `${STAGE_DOMAIN}/api/v2/exam` : 'http://localhost:5700/api/v2'
export const resumeBuilderBaseUrl = isProd ? "https://resume-api.alive.university/api/v1/resume-builder" : stage ? `${STAGE_DOMAIN}/api/resumebuilder` : `http://localhost:5800/api/v1/resume-builder`
export const onlineTutorialBaseUrl = isProd ? "https://alivecourse-api.alive.university/api" : stage ? `${STAGE_DOMAIN}/api/tutorial` : `http://localhost:5400/api`
export const discussionForumBaseUrl = isProd ? "https://alive-discussionforum-api.alive.university/api/v2" : stage ? `${STAGE_DOMAIN}/api/v2/forum` : `http://localhost:6500/api/v2`
export const classSessionApiBaseURL = isProd ? "https://alive-livesession-api.alive.university/api/v2" : stage ? `${STAGE_DOMAIN}/api/v2/sessions` : `http://localhost:6400/api/v2`
export const socketServerEndpoint = isProd ? `https://alive-attendance-cron-wl6d6.ondigitalocean.app` : stage ? STAGE_DOMAIN : "http://localhost:4000"

export const blobBaseUrl = `sgp1.digitaloceanspaces.com/content-ai/`

export const erpBaseURL = `https://acerp.acharyaerptech.in/api/lms`

export const headers = () => {
    const headersMap = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': true,
        "accept-language": localStorage.getItem( 'selectedLanguage' ) || 'en',
    }

    if ( sessionStorage.getItem( "impersonation_id_token" ) )
        headersMap.Authorization = `Bearer ${sessionStorage.getItem( "impersonation_id_token" )}`
    else
        headersMap.Authorization = localStorage.getItem( 'id_token' ) ? `Bearer ${localStorage.getItem( 'id_token' )}` : ""

    const meetingAccessToken = JSON.parse( sessionStorage.getItem( 'meetingAccessToken' ) || '{}' )
    headersMap["meeting-access-token"] = meetingAccessToken?.token || ""

    return headersMap
}

const headersFormdata = ( progressHandlers = {} ) => {
    const headersMap = {
        'Accept': 'application/json',
        "Content-Type": "multipart/form-data",
        'Authorization': 'Bearer ' + localStorage.getItem( 'id_token' )
    }
    if ( sessionStorage.getItem( "impersonation_id_token" ) )
        headersMap.Authorization = `Bearer ${sessionStorage.getItem( "impersonation_id_token" )}`
    else
        headersMap.Authorization = localStorage.getItem( 'id_token' ) ? `Bearer ${localStorage.getItem( 'id_token' )}` : ""
    return headersMap
}

const api = {
    signUp: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/signup`, payload )
    },
    signIn: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/signin`, payload )
    },
    signInERP: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/login/erp`, payload )
    },
    lmsLoginWithToken: ( payload ) => {
        return axios.post( baseURL + `/login/lms`, payload )
    },
    lmsImpersonationWithToken: ( payload ) => {
        return axios.post( baseURL + `/impersonation-login`, payload, { headers: headers() } )
    },
    logout: ( payload = {} ) => {
        return axios.post( baseURL + `/logout`, payload, { headers: headers() } )
    },
    signInExam: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/users/login`, payload )
    },
    fetchSubjectFeed: ( subject_code ) => {
        return axios.get( `${baseURL}/feed`, { headers: headers(), params: { subject_code } } )
    },
    fetchUserDetailsByEmail: ( payload ) => {
        return axios.post( baseURL + `/fetch-users-by-emails`, payload, { headers } )
    },

    // Manage Accounts
    getUser: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/user`, { headers: headers(), ...progressHandlers } )
    },
    updateUserProfileImage: ( payload, progressHandlers = {} ) => {
        return axios.put( baseURL + `/user`, payload, { headers: headersFormdata() } )
    },
    getUsers: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/user-accounts`, { headers: headers(), ...progressHandlers } )
    },
    getUserSubjects: ( params, progressHandlers = {} ) => {
        return axios.get( baseURL + `/user-subjects`, { headers: headers(), ...progressHandlers, params } )
    },
    getSubAdminAccounts: ( progressHandlers = {} ) => {
        return axios.get( baseURL + '/subadmin', { headers: headers(), ...progressHandlers } )
    },
    findUserDebugTimetable: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/find-user-timetable`, payload, { headers: headers(), ...progressHandlers } )
    },
    createUserAccount: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/user`, payload, { headers: headers(), ...progressHandlers } )
    },
    createSubAdminAccount: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + '/subadmin', payload, { headers: headers(), ...progressHandlers } )
    },
    updateUserAccount: ( payload, id, progressHandlers = {} ) => {
        return axios.put( baseURL + `/user/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateSubAdminAccount: ( payload, id, progressHandlers = {} ) => {
        return axios.put( baseURL + `/subadmin/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateUserStatus: ( payload, progressHandlers = {} ) => {
        return axios.put( baseURL + `/user-status`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteSubAdminAccount: ( id, progressHandlers = {} ) => {
        return axios.delete( baseURL + `/subadmin/${id}`, { headers: headers(), ...progressHandlers } )
    },
    sendFeedback: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/feedback`, payload, { headers: headers(), ...progressHandlers } )
    },
    createAcademicRule: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/academic-rule`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchAllBranches: () => {
        return axios.get( `${erpBaseURL}/specializationDetails` )
    },
    fetchAllAcademicYears: () => {
        return axios.get( `${erpBaseURL}/acYearDetails?tokenFlag=1` )
    },
    fetchAcademicRules: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academic-rule`, { headers: headers(), ...progressHandlers } )
    },
    fetchStudentAcademicRules: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academic-rule`, { headers: headers(), ...progressHandlers, params: params } )
    },
    deleteAcademicRule: ( id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/academic-rule/${id}`, { headers: headers(), ...progressHandlers } )
    },
    createAcademicRuleChecklist: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/academic-rule/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    importChecklistItems: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/academic-rule/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteChecklistItem: ( ids, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/academic-rule/checklist/delete`, { ids }, { headers: headers(), ...progressHandlers } )
    },
    updateChecklistItem: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/academic-rule/edit/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    getDepartmentAcademicRuleChecklist: ( id, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academic-rule/${id}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteAcademicRuleChecklist: ( institute, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academic-rule/institute/${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getUniqueChecklistItems: ( institute, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academic-rule/checklist/unique`, { headers: headers(), ...progressHandlers } )
    },
    getBranchStudentsProgressReport: ( payload, params, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/academics/audit`, payload, { headers: headers(), ...progressHandlers, params } )
    },
    fetchStudentAcademicRulesForAudit: ( id, params, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academics/audit/${id}`, { headers: headers(), ...progressHandlers, params } )
    },

    // Academic program auditors
    fetchFacultyDetailsById: ( id, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academics/faculty/${id}`, { headers: headers(), ...progressHandlers } )
    },
    createAcademicProgramAuditor: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/academics/auditor`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateAcademicProgramAuditor: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/academics/auditor/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    getAllAcademicProgramAuditors: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academics/auditor`, { headers: headers(), ...progressHandlers } )
    },
    getAllAcademicProgramAuditorAllowedBranches: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academics/auditor/allowed-branches`, { headers: headers(), ...progressHandlers } )
    },
    deleteProgramAuditor: ( id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/academics/auditor/${id}`, { headers: headers(), ...progressHandlers } )
    },
    downloadAcademicsStudentDataAttachment: ( key, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/academics/student-data/attachment`, { key }, { headers: headers(), ...progressHandlers, responseType: 'blob' } )
    },
    uploadAcademicsDocument: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/academic-rule/submit-document`, payload, { headers: headersFormdata() } )
    },

    // Batch
    getAllBatchAcademicYear: ( params, progressHandlers = {} ) => {
        return axios.get( baseURL + `/batch/get-academic-year`, { headers: headers(), ...progressHandlers, params } )
    },
    getAllBatch: ( params, progressHandlers = {} ) => {
        return axios.get( baseURL + `/batch`, { headers: headers(), ...progressHandlers, params } )
    },
    getUserAllBatchesAndSections: ( params ) => {
        return axios.get( baseURL + `/batch/user-batches-sections`, { headers: headers(), params } )
    },
    getAllSubjects: () => {
        return axios.get( `${studyMaterialBaseURL}/user/subjects`, { headers: headers() } )
    },
    // Notes
    uploadNotes: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/notes`, payload, { headers: headersFormdata() } )
    },
    deleteNotes: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/notes/delete`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchNotesByAuthor: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/notes/teacher`, { headers: headers(), ...progressHandlers } )
    },
    fetchNotesByStudent: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/notes/student`, { headers: headers(), ...progressHandlers } )
    },
    downloadNotes: ( url, progressHandlers = {} ) => {
        return axios.get( baseURL + `/notes/download?sourceUrl=${url}`, { headers: headers(), ...progressHandlers, responseType: 'blob' } )
    },

    // Study material
    uploadStudyMaterial: ( payload, progressHandler, progressHandlers = {} ) => {
        return axios.post( `${studyMaterialBaseURL}/study-material`, payload, { headers: headersFormdata(), onUploadProgress: progressHandler } )
    },
    deleteStudyMaterial: ( id, progressHandlers = {} ) => {
        return axios.delete( `${studyMaterialBaseURL}/study-material/${id}`, { headers: headers(), ...progressHandlers } )
    },
    getMaterials: ( institute, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material`, { headers: headers(), ...progressHandlers, params: { institute } } )
    },
    getMaterialsBySubject: ( subject, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material/subject-materials`, { headers: headers(), ...progressHandlers, params: { subject } } )
    },
    getBranchMaterials: ( institute, code, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material/${institute}/branch/${code}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteMaterials: ( institute, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material/institute/${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getMaterial: ( id, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material/${id}`, { headers: headers(), ...progressHandlers } )
    },
    updateMaterial: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${studyMaterialBaseURL}/study-material/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    downloadMaterial: ( id, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material/${id}/download`, { headers: headers(), ...progressHandlers } )
    },
    getMaterialBatches: ( id, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material/${id}/batches`, { headers: headers(), ...progressHandlers } )
    },
    getAttachments: ( id, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/study-material/${id}/attachments`, { headers: headers(), ...progressHandlers } )
    },
    uploadAttachments: ( id, payload, progressHandler, progressHandlers = {} ) => {
        return axios.post( `${studyMaterialBaseURL}/study-material/${id}/add_attachments`, payload, { headers: headersFormdata(), onUploadProgress: progressHandler } )
    },
    renameAttachment: ( material_id, id, payload, progressHandlers = {} ) => {
        return axios.put( `${studyMaterialBaseURL}/study-material/${material_id}/attachment/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteStudyMaterialAttachment: ( id, progressHandlers = {} ) => {
        return axios.delete( `${studyMaterialBaseURL}/study-material/attachment/${id}`, { headers: headers(), ...progressHandlers } )
    },
    downloadAttachment: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${studyMaterialBaseURL}/study-material/attachment/${id}/download`, payload, { headers: headers(), ...progressHandlers } )
    },
    grantAccess: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${studyMaterialBaseURL}/study-material/${id}/grant`, payload, { headers: headers(), ...progressHandlers } )
    },
    revokeAccess: ( id, accessId, payload, progressHandlers = {} ) => {
        return axios.post( `${studyMaterialBaseURL}/study-material/${id}/revoke/${accessId}`, payload, { headers: headers(), ...progressHandlers } )
    },

    // Exams

    fetchExamInstructions: ( params, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/instructions`, { headers: headers(), ...progressHandlers, params } )
    },
    updateExamInstructions: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/instructions`, payload, { headers: headers(), ...progressHandlers } )
    },
    getExam: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchExamsByDept: ( deptCode, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/dept/${deptCode}`, { headers: headers(), ...progressHandlers } )
    },
    fetchExamsByInstitute: ( institute, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/institute/${institute}`, { headers: headers(), ...progressHandlers } )
    },
    fetchExamsBySubject: ( subject, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/get-by-subject`, { headers: headers(), ...progressHandlers, params: { subject } } )
    },
    fetchPendingExams: ( params, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/pending`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchExamEvents: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/events-timeline`, { headers: headers(), ...progressHandlers, params } )
    },
    getAllExams: ( progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/`, { headers: headers(), ...progressHandlers } )
    },
    retrieveLegacyAliveExams: () => {
        return axios.get( `${examBaseURL}/exams/retrieve-legacy-exams`, { headers: headers() } )
    },
    getInstituteExamStats: ( institute ) => {
        return axios.get( `${examBaseURL}/exams/institute/${institute}/stats`, { headers: headers() } )
    },
    createExam: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/`, payload, { headers: headersFormdata() } )
    },
    updateExam: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}`, payload, { headers: headersFormdata() } )
    },
    rescheduleExam: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}/reschedule`, payload, { headers: headers(), ...progressHandlers } )
    },
    convertDocxToHtml: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/convert-doc-to-txt`, payload )
    },
    cleanupTemporaryStoredData: ( payload ) => {
        return axios.post( `${examBaseURL}/exams/docx-images-cleanup`, payload )
    },
    fetchQuestionDetails: ( id, qid ) => {
        return axios.get( `${examBaseURL}/exams/${id}/question/${qid}`, { headers: headers() } )
    },
    addQuestion: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${id}/addquestion`, payload, { headers: headersFormdata() } )
    },
    updateQuestion: ( id, qid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}/question/${qid}`, payload, { headers: headersFormdata() } )
    },
    updateExamQuestionOption: ( exam_id, question_id, option_id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${exam_id}/question/${question_id}/option/${option_id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    removeExamQuestionOption: ( exam_id, question_id, option_id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/exams/${exam_id}/question/${question_id}/option/${option_id}`, { headers: headers(), ...progressHandlers } )
    },
    addNewOptionToExamQuestion: ( exam_id, question_id, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${exam_id}/question/${question_id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteQuestion: ( id, qid, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/exams/${id}/question/${qid}`, { headers: headers(), ...progressHandlers } )
    },
    addOption: ( id, qid, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${id}/question/${qid}`, payload, { headers: headers(), ...progressHandlers } )
    },
    removeOption: ( id, qid, oid, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/exams/${id}/question/${qid}/option/${oid}`, { headers: headers(), ...progressHandlers } )
    },
    updateOption: ( id, qid, oid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}/question/${qid}/option/${oid}`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchQuestions: ( id, params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/${id}/questions`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchQuestionsForAttempt: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/${id}/questions/attempt`, { headers: headers(), ...progressHandlers } )
    },
    getAudioPresignedUrl: ( exam_id, question_id, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${exam_id}/question/${question_id}/fetch-attachment`, payload, { headers: headers(), ...progressHandlers } )
    },
    publish: ( id, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/publish/${id}`, {}, { headers: headers(), ...progressHandlers } )
    },
    deleteExam: ( id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/exams/${id}`, { headers: headers(), ...progressHandlers } )
    },
    attempt: ( id, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${id}/attempt`, {}, { headers: headers(), ...progressHandlers } )
    },
    startExam: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}/start/${pid}`, payload || {}, { headers: headers(), ...progressHandlers } )
    },
    finishExam: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}/participation/${pid}/finish`, payload || {}, { headers: headers(), ...progressHandlers } )
    },
    registerExamAttemptFault: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}/participation/${pid}/registerfault`, payload || {}, { headers: headers(), ...progressHandlers } )
    },
    fetchUserParticipations: ( progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/users/participation`, { headers: headers(), ...progressHandlers } )
    },
    fetchUserParticipation: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/users/participation/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchExamParticipation: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/${id}/participation`, { headers: headers(), ...progressHandlers } )
    },
    fetchAllParticipations: ( progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/participations/all`, { headers: headers(), ...progressHandlers } )
    },
    fetchParticipationData: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/${id}/participation/${pid}`, { headers: headers(), ...progressHandlers } )
    },
    fetchParticipationSubmissions: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/exams/${id}/submissions/${pid}`, { headers: headers(), ...progressHandlers } )
    },
    updateExamParticipationAttempt: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/exams/${id}/participation/${pid}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteExamParticipation: ( id, pid, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/exams/${id}/participation/${pid}`, { headers: headers(), ...progressHandlers } )
    },
    submitAnswer: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${id}/submissions/${pid}`, payload, { headers: headers(), ...progressHandlers } )
    },
    submitRemark: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${id}/participation/${pid}/remark`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchEvaluationScheme: ( id ) => {
        return axios.get( `${examBaseURL}/exams/${id}/evaluationscheme`, { headers: headers() } )
    },
    uploadQuestionImage: ( payload ) => {
        return axios.post( `${examBaseURL}/upload-question-image`, payload, { headers: headersFormdata() } )
    },
    deleteQuestionImage: ( payload ) => {
        return axios.post( `${examBaseURL}/delete-question-image`, payload, { headers: headers() } )
    },

    // assignment
    uploadAssignment: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment`, payload, { headers: headersFormdata() } )
    },
    ///assignment/update
    updateAssignment: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment/update`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteAssignment: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment/delete`, payload, { headers: headers(), ...progressHandlers } )
    },
    uploadAssignmentSubmission: ( payload, params, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment/submission`, payload, { headers: headersFormdata(), params } )
    },
    deleteAssignmentSubmitted: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment/submission/delete`, payload, { headers: headers(), ...progressHandlers } )
    },
    setAssignmentScore: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment/score`, payload, { headers: headers(), ...progressHandlers } )
    },
    bulkUploadAssignmentScore: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment/bulk-score`, payload, { headers: headers(), ...progressHandlers } )
    },
    setAssignmentRemarks: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/assignment/remark`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchAssignmentSubmission: ( assignment_id, progressHandlers = {} ) => {
        return axios.get( baseURL + `/assignment/submission?assignment_id=${assignment_id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchAssignmentByAuthor: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/assignment/teacher`, { headers: headers(), ...progressHandlers } )
    },
    fetchAssignmentByStudent: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/assignment/student`, { headers: headers(), ...progressHandlers } )
    },
    fetchSubjectAssignment: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/assignment/`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchDueOrRecentAssignment: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/assignment/recentorpending`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchAssignmentEvents: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/assignment/events`, { headers: headers(), ...progressHandlers, params } )
    },
    downloadAssignment: ( url, signedUrl, progressHandlers = {} ) => {
        return axios.get( baseURL + `/assignment/download?sourceUrl=${url}&preSignedUrl=${signedUrl}`, { headers: headers(), ...progressHandlers, responseType: !( signedUrl === true || signedUrl === 1 ) && 'blob' } )
    },

    // Proctoring
    fetchProctorAcademicYear: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/proctees/academic-years`, { headers: headers(), ...progressHandlers } )
    },
    fecthProcteeDetails: ( id, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/proctee/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchProcteeAcademicRuleDetails: ( id, params, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/academic-rule/proctee/${id}`, { headers: headers(), ...progressHandlers, params } )
    },
    removeStudentAttachment: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/proctee/delete-attachment/`, payload, { headers: headers(), ...progressHandlers } )
    },
    submitChecklistStudentData: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/proctee/submit`, payload, { headers: headersFormdata() } )
    },
    fetchChecklistStudentData: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/proctee/data/${payload.student_id}`, payload, { headers: headersFormdata() } )
    },
    resetChecklistData: ( payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/proctee/reset-data/`, payload, { headers: headers(), ...progressHandlers } )
    },

    //Org
    //https://www.acharyainstitutes.in/index.php?r=acerp-api/institutes
    getAllOrganization: () => {
        return axios.get( `${erpBaseURL}/schoolDetailsForLms` )
    },
    getAllOrganizationBranches: ( instituteCode, progressHandlers = {} ) => {
        return axios.get( studyMaterialBaseURL + `/institute/${instituteCode}/branches` )
    },
    getOrganizationStats: ( instituteCode, progressHandlers = {} ) => {
        return axios.get( studyMaterialBaseURL + `/institute/${instituteCode}/stats`, { headers: headers(), ...progressHandlers } )
    },
    // getOrganization: ()=>{
    //     return axios.get(baseURL+`/organization`, { headers : headers(),...progressHandlers });
    // },
    getOrganization: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/organization`, { headers: headers(), ...progressHandlers } )
    },
    createOrganization: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/organization`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateOrganization: ( payload, progressHandlers = {} ) => {
        return axios.put( baseURL + `/organization`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteOrganization: ( payload, progressHandlers = {} ) => {
        return axios.delete( baseURL + `/organization`, payload, { headers: headers(), ...progressHandlers } )
    },

    // department
    getAllDepartment: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/all-department` )
    },
    getDepartment: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/department`, { headers: headers(), ...progressHandlers } )
    },
    createDepartment: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/department`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateDepartment: ( payload, progressHandlers = {} ) => {
        return axios.put( baseURL + `/department`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteDepartment: ( id, progressHandlers = {} ) => {
        //console.log(headers)
        return axios.delete( baseURL + `/department/${id}`, { headers: headers(), ...progressHandlers } )
    },
    // class room with erp
    startSession: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/start-session`, payload, { headers: headers(), ...progressHandlers } )
    },
    joinSession: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/join-session`, payload, { headers: headers(), ...progressHandlers } )
    },
    joinSessionAsModerator: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/join-session-moderator`, payload, { headers: headers(), ...progressHandlers } )
    },
    endSession: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/end-session`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchFeedbackQuestions: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/session/feedback/questions`, { headers: headers(), ...progressHandlers } )
    },
    submitSessionFeedback: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/session/${id}/feedback`, payload, { headers: headers(), ...progressHandlers } )
    },
    addFeedbackQuestion: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/session/feedback/question`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchFeedbacks: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/feedbacks`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateFeedbackQuestion: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/session/feedback/question/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteFeedbackQuestion: ( id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/session/feedback/question/${id}`, { headers: headers(), ...progressHandlers } )
    },
    getFeedbackSessions: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/feedback/sessions`, { headers: headers(), ...progressHandlers } )
    },
    fetchStudentFeedbacks: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/student/feedbacks`, { headers: headers(), ...progressHandlers } )
    },
    getMySession: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/sessions`, { headers: headers(), ...progressHandlers } )
    },
    getClassesByDate: ( params = {} ) => {
        return axios.get( `${baseURL}/classes`, { headers: headers(), params } )
    },
    getAllRecording: ( icode, progressHandlers = {} ) => {
        return axios.get( baseURL + `/recording?institute=` + icode, { headers: headers(), ...progressHandlers } )
    },
    getFacultyRecording: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/recording/faculty`, { headers: headers(), ...progressHandlers } )
    },
    auditSession: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/audit-session`, { headers: headers(), ...progressHandlers } )
    },
    auditFeedback: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/audit-feedback-log`, payload, { headers: headers(), ...progressHandlers } )
    },
    ///exam/teacher
    // examFetch: ( payload ,progressHandlers={}) => {
    //     return axios.get( baseURL + `/exam`, { headers: headers(),...progressHandlers } )
    // },

    // fetchExamSubmission: ( id ,progressHandlers={}) => {
    //     return axios.get( baseURL + `/exam/submission?exam_id=${id}`, { headers: headers(),...progressHandlers } )
    // },
    // examStudent: ( payload ,progressHandlers={}) => {
    //     return axios.get( baseURL + `/exam/student`, { headers: headers(),...progressHandlers } )
    // },
    // submitExamAnswers: ( payload ,progressHandlers={}) => {
    //     return axios.post( baseURL + `/exam/submission`, payload, { headers: headersFormdata() } )
    // },
    // assignScore: ( payload ,progressHandlers={}) => {
    //     return axios.post( baseURL + `/exam/score`, payload, { headers: headers(),...progressHandlers } )
    // },


    // room
    getOrgRoom: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/getrooms`, payload, { headers: headers(), ...progressHandlers } )
    },
    getRoom: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/room`, { headers: headers(), ...progressHandlers } )
    },
    createRoom: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/room`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateRoom: ( payload, progressHandlers = {} ) => {
        return axios.put( baseURL + `/room`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteRoom: ( api_id, progressHandlers = {} ) => {
        return axios.delete( baseURL + `/room/${api_id}`, { headers: headers(), ...progressHandlers } )
    },
    getSessionClassAttendence: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/attentence-session`, payload, { headers: headers(), ...progressHandlers } )
    },
    searchAttendence: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/attendence/search`, payload, { headers: headers(), ...progressHandlers } )
    },
    attendenceAudit: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/attendance/audit`, payload, { headers: headers(), ...progressHandlers } )
    },
    ///attendence/student
    studentAttendence: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/attendence/student`, payload, { headers: headers(), ...progressHandlers } )
    },
    // api settings -->> Start
    createApiProvider: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/provider-api`, payload, { headers: headers(), ...progressHandlers } )
    },
    getApiProviders: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/provider-api`, { headers: headers(), ...progressHandlers } )
    },
    updateApiProvider: ( payload, api_id, progressHandlers = {} ) => {
        return axios.put( baseURL + `/provider-api/${api_id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteApiProvider: ( api_id, progressHandlers = {} ) => {
        return axios.delete( baseURL + `/provider-api/${api_id}`, { headers: headers(), ...progressHandlers } )
    },
    // api settings -->> End
    // analytics -->> Start
    getNodes: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/nodes`, { headers: headers(), ...progressHandlers } )
    },

    getServerStat: ( progressHandlers = {} ) => {
        return axios.get( baseURL + `/serverstat` )
    },

    doLogout: ( progressHandlers = {} ) => {
        localStorage.removeItem( "isLoggedIn" )
        //return false;
    },
    isLoggedIn: ( progressHandlers = {} ) => {
        return localStorage.getItem( "isLoggedIn" )
    },
    createUser: ( payload, progressHandlers = {} ) => {
        return axios.post( baseURL + `/user`, payload )
    },
    updateUser: ( payload, id, progressHandlers = {} ) => {
        return axios.put( baseURL + `/user/${id}`, payload )
    },
    updatePassword: ( payload, progressHandlers = {} ) => {
        return axios.put( baseURL + `/change-password`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteUser: ( id, progressHandlers = {} ) => {
        return axios.delete( baseURL + `/user/${id}` )
    },

    // Institute routes
    getInstituteFacultyCount: ( institute, progressHandlers = {} ) => {
        return axios.get( baseURL + `/stats/faculty/count?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteStudentCount: ( institute, progressHandlers = {} ) => {
        return axios.get( baseURL + `/stats/student/count?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteBranchCount: ( institute, progressHandlers = {} ) => {
        return axios.get( baseURL + `/stats/branch/count?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteBranchUserCount: ( institute, progressHandlers = {} ) => {
        return axios.get( baseURL + `/stats/branchuser/count?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteAssignmentCount: ( institute, progressHandlers = {} ) => {
        return axios.get( baseURL + `/stats/assignment/count?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteStudyMaterialCount: ( institute, progressHandlers = {} ) => {
        return axios.get( studyMaterialBaseURL + `/audit/count?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    getInstituteExamCount: ( institute ) => {
        return axios.get( examBaseURL + `/exams/stats/count?institute=${institute}`, { headers: headers() } )
    },
    getPracticeSessionsCount: () => {
        return axios.get( `${baseURL}/stats/practice-sessions/count`, { headers: headers() } )
    },

    // Online Tutorials
    addOnlineCourse: ( payload, progressHandlers = {} ) => {
        return axios.post( `${onlineTutorialBaseUrl}/online-course`, payload, { headers: headersFormdata() } )
    },
    updateCourse: ( course_id, payload, progressHandlers = {} ) => {
        return axios.put( `${onlineTutorialBaseUrl}/online-course/${course_id}`, payload, { headers: headersFormdata() } )
    },
    addNewModule: ( course_id, payload, progressHandlers = {} ) => {
        return axios.post( `${onlineTutorialBaseUrl}/online-course/${course_id}/module`, payload, { headers: headers(), ...progressHandlers } )
    },
    enroll: ( course_id, payload, progressHandlers = {} ) => {
        return axios.post( `${onlineTutorialBaseUrl}/onine-course/${course_id}/enroll`, payload, { headers: headers(), ...progressHandlers } )
    },
    getEnrolledCourses: ( progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/onine-course/enrolled`, { headers: headers(), ...progressHandlers } )
    },
    getEnrolledCoursesProgress: ( progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/progress/enrolled`, { headers: headers(), ...progressHandlers } )
    },
    getCourseProgressData: ( progress_id, progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/progress/${progress_id}`, { headers: headers(), ...progressHandlers } )
    },
    getCourseEnrollmentStatus: ( course_id, progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/onine-course/${course_id}/enroll`, { headers: headers(), ...progressHandlers } )
    },
    updateModuleName: ( module_id, payload, progressHandlers = {} ) => {
        return axios.put( `${onlineTutorialBaseUrl}/module/${module_id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    addAttachment: ( module_id, payload, progressHandler, progressHandlers = {} ) => {
        return axios.post( `${onlineTutorialBaseUrl}/module/${module_id}`, payload, { headers: headersFormdata(), onDownloadProgress: progressHandler } )
    },
    getCourseAttachment: ( id, progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/attachment/${id}`, { headers: headersFormdata() } )
    },
    reorderCourseModules: ( newOrder, progressHandlers = {} ) => {
        return axios.put( `${onlineTutorialBaseUrl}/online-course/modules`, { newOrder }, { headers: headers(), ...progressHandlers } )
    },
    deleteCourseAttachment: ( id, progressHandlers = {} ) => {
        return axios.delete( `${onlineTutorialBaseUrl}/attachment/${id}`, { headers: headers(), ...progressHandlers } )
    },
    getCourses: ( progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/online-course`, { headers: headers(), ...progressHandlers } )
    },
    getSubjectCourses: ( params, progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/online-course/subject`, { headers: headers(), ...progressHandlers, params } )
    },
    getCourse: ( id, progressHandlers = {} ) => {
        return axios.get( `${onlineTutorialBaseUrl}/online-course/${id}`, { headers: headers(), ...progressHandlers } )
    },
    startCourse: ( id, progressHandlers = {} ) => {
        return axios.put( `${onlineTutorialBaseUrl}/progress/${id}/start`, { progress_id: id }, { headers: headers(), ...progressHandlers } )
    },
    startAttachment: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${onlineTutorialBaseUrl}/progress/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateProgressDetail: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${onlineTutorialBaseUrl}/progress/update/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteModule: ( id, progressHandlers = {} ) => {
        return axios.delete( `${onlineTutorialBaseUrl}/module/${id}`, { headers: headers(), ...progressHandlers } )
    },
    publishCourse: ( id, progressHandlers = {} ) => {
        return axios.put( `${onlineTutorialBaseUrl}/online-course/${id}/publish`, {}, { headers: headers(), ...progressHandlers } )
    },
    updateAttachmentName: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${onlineTutorialBaseUrl}/attachment/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteCourse: ( id, progressHandlers = {} ) => {
        return axios.delete( `${onlineTutorialBaseUrl}/online-course/${id}`, { headers: headers(), ...progressHandlers } )
    },

    // Resume Builder
    createResumeForm: ( payload, progressHandlers = {} ) => {
        return axios.post( `${resumeBuilderBaseUrl}/forms`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchResumeForms: ( progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/forms`, { headers: headers(), ...progressHandlers } )
    },
    fetchResumeForm: ( id, progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/forms/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchInstituteFormStatus: ( institute, progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/forms/institute_status?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    fetchStudentForm: ( progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/forms/student-form`, { headers: headers(), ...progressHandlers } )
    },
    deleteResumeForm: ( id, progressHandlers = {} ) => {
        return axios.delete( `${resumeBuilderBaseUrl}/forms/${id}`, { headers: headers(), ...progressHandlers } )
    },
    updateResumeForm: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/forms/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateResumeFormJson: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/forms/${id}/fields`, payload, { headers: headers(), ...progressHandlers } )
    },
    publishResumeForm: ( id, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/forms/${id}/publish`, { id: id }, { headers: headers(), ...progressHandlers } )
    },
    createResumeEntity: ( payload, progressHandlers = {} ) => {
        return axios.post( `${resumeBuilderBaseUrl}/entity`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchResumeEntities: ( progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/entities`, { headers: headers(), ...progressHandlers } )
    },
    fetchResumeEntity: ( id, progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/entity/${id}`, { headers: headers(), ...progressHandlers } )
    },
    deleteResumeEntity: ( id, progressHandlers = {} ) => {
        return axios.delete( `${resumeBuilderBaseUrl}/entity/${id}`, { headers: headers(), ...progressHandlers } )
    },
    updateResumeEntity: ( payload, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/entity/${payload.id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchStudentResumeInfo: ( progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/student-info`, { headers: headers(), ...progressHandlers } )
    },
    fetchStudentResumeProgress: ( progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/student-info/progress`, { headers: headers(), ...progressHandlers } )
    },
    uploadStudentProfileToResume: ( payload, progressHandlers = {} ) => {
        return axios.post( `${resumeBuilderBaseUrl}/student-info/profile-image`, payload, { headers: headersFormdata() } )
    },
    uploadStudentDocToResume: ( payload, progressHandlers = {} ) => {
        return axios.post( `${resumeBuilderBaseUrl}/student-info/document`, payload, { headers: headersFormdata() } )
    },
    deleteResumeDocuments: ( payload, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/student-info/deletedocuments`, payload, { headers: headers(), ...progressHandlers } )
    },
    getResumeFilePresignedUrl: ( key, progressHandlers = {} ) => {
        return axios.post( `${resumeBuilderBaseUrl}/getfile`, { key }, { headers: headers(), ...progressHandlers } )
    },
    updateStudentResumeInfo: ( payload, progressHandlers = {} ) => {
        return axios.post( `${resumeBuilderBaseUrl}/student-info`, payload, { headers: headers(), ...progressHandlers } )
    },
    clearResumeSection: ( payload, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/student-info/clearsection`, payload, { headers: headers(), ...progressHandlers } )
    },
    clearResumeData: ( payload, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/student-info/clear`, payload, { headers: headers(), ...progressHandlers } )
    },
    createTemplate: ( payload, progressHandlers = {} ) => {
        return axios.post( `${resumeBuilderBaseUrl}/templates`, payload, { headers: headers(), ...progressHandlers } )
    },
    getTemplates: ( institute, progressHandlers = {} ) => {
        if ( institute )
            return axios.get( `${resumeBuilderBaseUrl}/templates`, { headers: headers(), ...progressHandlers } )
        else
            return axios.get( `${resumeBuilderBaseUrl}/templates?institute=${institute}`, { headers: headers(), ...progressHandlers } )
    },
    deleteResumeTemplate: ( id, progressHandlers = {} ) => {
        return axios.delete( `${resumeBuilderBaseUrl}/templates/${id}`, { headers: headers(), ...progressHandlers } )
    },
    updateTemplate: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${resumeBuilderBaseUrl}/templates/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    getTemplate: ( id, progressHandlers = {} ) => {
        return axios.get( `${resumeBuilderBaseUrl}/templates/${id}`, { headers: headers(), ...progressHandlers } )
    },

    // Settings
    addSetting: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/setting`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateSetting: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/setting/${id}`, payload, { headers: headersFormdata() } )
    },
    updateSettingDetails: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/setting/${id}/edit`, payload, { headers: headers(), ...progressHandlers } )
    },
    getSettings: ( query, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/setting`, { params: query, headers: headers(), ...progressHandlers } )
    },
    addSettingsModule: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/setting/module`, payload, { headers: headers(), ...progressHandlers } )
    },
    getSettingsModules: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/setting/module`, { headers: headers(), ...progressHandlers } )
    },
    deleteSettings: ( id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/setting/${id}`, { headers: headers(), ...progressHandlers } )
    },
    deleteSettingAttachment: ( id, payload = {}, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/setting/${id}/attachment`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteSettingModule: ( moduleId, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/setting/module/${moduleId}`, { headers: headers(), ...progressHandlers } )
    },
}

api.featurePermissions = {
    fetchPermissions: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/feature-permissions`, { headers: headers(), ...progressHandlers } )
    },
    addNewFeature: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/feature-permissions`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchInstituteDepartmentAndBranches: ( payload, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/feature-permissions/branches-and-departments`, { headers: headers(), ...progressHandlers } )
    },
    updatePermissions: ( featureKey, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/feature-permissions/${featureKey}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteFeaturePermissions: ( featureKey, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/feature-permissions/${featureKey}`, { headers: headers(), ...progressHandlers } )
    },
}

api.jobWorkers = {
    fetchAttendanceJobs: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/jobs/attendance`, { headers: headers(), params, ...progressHandlers } )
    },

    deleteAttendanceJobs: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/jobs/attendance/delete`, payload, { headers: headers(), ...progressHandlers } )
    },
}

api.temporaryUsers = {
    fetchBatches: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/temporary-users/batch`, { headers: headers(), ...progressHandlers } )
    },
    addBatch: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/temporary-users/batch`, payload, { headers: headers(), ...progressHandlers } )
    },
    addUser: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/temporary-users/batch/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteBatch: ( id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/temporary-users/batch/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchBatchUsers: ( id, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/temporary-users/batch/${id}`, { headers: headers(), ...progressHandlers } )
    },
    deleteUsers: ( ids, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/temporary-users/delete`, ids, { headers: headers(), ...progressHandlers } )
    }

}

api.discussionForum = {
    createDiscussion: ( payload, progressHandlers = {} ) => {
        return axios.post( `${discussionForumBaseUrl}/discussion`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateDiscussion: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${discussionForumBaseUrl}/discussion/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchDiscussions: ( params, progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/discussion`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchUserDiscussions: ( progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/user/discussions`, { headers: headers(), ...progressHandlers } )
    },
    fetchDiscussion: ( id, progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/discussion/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchDiscussionComment: ( id, progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/discussion/${id}/comments`, { headers: headers(), ...progressHandlers } )
    },
    deleteDiscussion: ( id, progressHandlers = {} ) => {
        return axios.delete( `${discussionForumBaseUrl}/discussion/${id}`, { headers: headers(), ...progressHandlers } )
    },
    deleteComment: ( id, progressHandlers = {} ) => {
        return axios.delete( `${discussionForumBaseUrl}/discussion/comment/${id}`, { headers: headers(), ...progressHandlers } )
    },
    getSubjects: ( progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/user/subjects`, { headers: headers(), ...progressHandlers } )
    },
    getUserVotes: ( progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/user/votes`, { headers: headers(), ...progressHandlers } )
    },
    uploadImage: ( payload, progressHandlers = {} ) => {
        return axios.post( `${discussionForumBaseUrl}/discussion/file/image-upload`, payload, { headers: headersFormdata() } )
    },
    uploadVideo: ( payload, progressHandlers = {} ) => {
        return axios.post( `${discussionForumBaseUrl}/discussion/file/video-upload`, payload, { headers: headersFormdata() } )
    },
    postComment: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${discussionForumBaseUrl}/discussion/${id}/comment`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateComment: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${discussionForumBaseUrl}/discussion/comment/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    voteComment: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${discussionForumBaseUrl}/discussion/comment/${id}/vote`, payload, { headers: headers(), ...progressHandlers } )
    },
    voteDiscussion: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${discussionForumBaseUrl}/discussion/${id}/vote`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteFile: ( payload ) => {
        return axios.post( `${discussionForumBaseUrl}/discussion/file/delete-file`, payload, { headers: headers() } )
    },
    retrieveLegacyAliveDiscussions: () => {
        return axios.get( `${discussionForumBaseUrl}/discussion/retrieve-legacy-discussions`, { headers: headers() } )
    },
}

api.quiz = {
    createQuiz: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/quizzes/`, payload, { headers: headersFormdata() } )
    },
    createQuickQuiz: ( payload ) => {
        return axios.post( `${examBaseURL}/quizzes/quick-quiz`, payload, { headers: headers() } )
    },
    fetchQuizes: ( params ) => {
        return axios.get( `${examBaseURL}/quizzes/`, { headers: headers(), params } )
    },
    fetchClassQuizInstances: () => {
        return axios.get( `${examBaseURL}/quizzes/class-instances`, { headers: headers() } )
    },
    fetchQuiz: ( id ) => {
        return axios.get( `${examBaseURL}/quizzes/${id}`, { headers: headers() } )
    },
    createQuizInstance: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/quizzes/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    rescheduleQuizInstance: ( id, instance_id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/quizzes/${id}/instance/${instance_id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    startQuiz: ( quizId, instanceId, params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/${quizId}/start/${instanceId}`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchQuizQuestionsForAttempt: ( quizId, instanceId, attemptId, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/${quizId}/instance/${instanceId}/attempt/${attemptId}`, { headers: headers(), ...progressHandlers } )
    },
    fetchQuizInstances: ( quizId, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/${quizId}/instance`, { headers: headers(), ...progressHandlers } )
    },
    fetchAllInstances: ( progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/instances`, { headers: headers(), ...progressHandlers } )
    },
    submitAnswers: ( quizId, instanceId, attemptId, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/quizzes/${quizId}/instance/${instanceId}/attempt/${attemptId}`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchAttemptScore: ( quizId, instanceId, attemptId, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/${quizId}/instance/${instanceId}/attempt/${attemptId}/score`, { headers: headers(), ...progressHandlers } )
    },
    fetchQuizInstanceScores: ( quizId, instanceId, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/${quizId}/instance/${instanceId}/scores`, { headers: headers(), ...progressHandlers } )
    },
    fetchBatchOrSectionAssignedStudentDetails: ( params = {}, progressHandlers = {} ) => {
        const accessToken = decode( localStorage.getItem( "id_token" ) || "" )?.token
        return axios.get( `${erpBaseURL}/batchOrSectionAssignedStudentDetails`, { params, headers: { accessToken }, ...progressHandlers, } )
    },
    fetchQuizInstanceForStudent: ( quizId, instanceId, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/${quizId}/instance/${instanceId}`, { headers: headers(), ...progressHandlers } )
    },
    addQuestionBank: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/questionbank/`, payload, { headers: headers(), ...progressHandlers } )
    },
    createTopic: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/questionbank/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteQuestionBank: ( id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/questionbank/${id}`, { headers: headers(), ...progressHandlers } )
    },
    deleteTopic: ( bankId, id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/questionbank/${bankId}/topic/${id}`, { headers: headers(), ...progressHandlers } )
    },
    deleteQuestion: ( bankId, topicId, id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/questionbank/${bankId}/topic/${topicId}/question/${id}`, { headers: headers(), ...progressHandlers } )
    },
    addQuestions: ( bankId, topicId, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/questionbank/${bankId}/topic/${topicId}`, payload, { headers: headers(), ...progressHandlers } )
    },
    editQuestionbankTopicName: ( bankId, topicId, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/questionbank/${bankId}/topic/${topicId}`, payload, { headers: headers(), ...progressHandlers } )
    },
    updateQuestionBankQuestion: ( bankId, topicId, questionId, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/questionbank/${bankId}/topic/${topicId}/question/${questionId}`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchQuestionBanks: ( params, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/questionbank/`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchQuestionBank: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/questionbank/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchQuestionBankQuestions: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/questionbank/${id}/questions`, { headers: headers(), ...progressHandlers } )
    },
    editQuestionbankName: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/questionbank/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteQuiz: ( id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/quizzes/${id}`, { headers: headers(), ...progressHandlers } )
    },
    deleteInstance: ( quiz_id, instance_id ) => {
        return axios.delete( `${examBaseURL}/quizzes/${quiz_id}/instance/${instance_id}`, { headers: headers() } )
    },
    retrieveLegacyAliveQuizzes: () => {
        return axios.get( `${examBaseURL}/quizzes/retrieve-legacy-quizzes`, { headers: headers() } )
    },
    retrieveLegacyAliveQuestionBanks: () => {
        return axios.get( `${examBaseURL}/questionbank/retrieve-legacy-question-banks`, { headers: headers() } )
    },
    fetchMonthlyReport: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/quizzes/faculty-quiz-report`, { headers: headers(), ...progressHandlers, params } )
    },
}

api.liveSessions = {
    createLiveSession: ( payload ) => {
        return axios.post( `${classSessionApiBaseURL}/livesession`, payload, { headers: headers() } )
    },
    updateLiveSession: ( id, payload ) => {
        return axios.put( `${classSessionApiBaseURL}/livesession/${id}`, payload, { headers: headers() } )
    },
    fetchLiveSessions: ( params ) => {
        return axios.get( `${classSessionApiBaseURL}/livesession`, { headers: headers(), params } )
    },
    fetchLiveSession: ( id ) => {
        return axios.get( `${classSessionApiBaseURL}/livesession/${id}`, { headers: headers() } )
    },
    addResource: ( payload, progressFunc, downProgressFunc, signal ) => {
        return axios.post( `${classSessionApiBaseURL}/resource`, payload, { headers: headersFormdata(), onUploadProgress: progressFunc, onDownloadProgress: downProgressFunc, signal, timeout: 7200000 } )
    },
    linkResource: ( id, payload ) => {
        return axios.post( `${classSessionApiBaseURL}/livesession/${id}`, payload, { headers: headers() } )
    },
    unlinkResource: ( sessionId, relationId ) => {
        return axios.delete( `${classSessionApiBaseURL}/livesession/${sessionId}/unlink/${relationId}`, { headers: headers() } )
    },
    fetchResources: ( params ) => {
        return axios.get( `${classSessionApiBaseURL}/resource`, { headers: headers(), params } )
    },
    enableResource: ( sessionId, relationId ) => {
        return axios.put( `${classSessionApiBaseURL}/livesession/${sessionId}/enable/${relationId}`, {}, { headers: headers() } )
    },
    disableResource: ( sessionId, relationId ) => {
        return axios.put( `${classSessionApiBaseURL}/livesession/${sessionId}/disable/${relationId}`, {}, { headers: headers() } )
    },
    extractLinksMetadata: ( payload ) => {
        return axios.post( `${classSessionApiBaseURL}/resource/extract-metadata`, payload, { headers: headers() } )
    },
    fetchLiveSessionResourceLink: ( session_id, relation_id, payload, downloadProgress ) => {
        return axios.post( `${classSessionApiBaseURL}/livesession/${session_id}/resource/${relation_id}`, payload, { headers: headers(), onDownloadProgress: downloadProgress, onUploadProgress: downloadProgress } )
    },
    deleteResource: ( id ) => {
        return axios.delete( `${classSessionApiBaseURL}/resource/${id}`, { headers: headers() } )
    },
    deleteLiveSession: ( id ) => {
        return axios.delete( `${classSessionApiBaseURL}/livesession/${id}`, { headers: headers() } )
    },
    retrieveLegacyAliveLivesessions: ( id ) => {
        return axios.get( `${classSessionApiBaseURL}/livesession/retrieve-legacy-live-sessions`, { headers: headers() } )
    },
}

api.aimentor = {
    saveSubjectSyllabus: ( subject_code, payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/aimentor/syllabus/${subject_code}`, payload, { headers: headers(), ...progressHandlers } )
    },
    getSubjectSyllabus: ( subject_code, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/aimentor/syllabus/${subject_code}`, { headers: headers(), ...progressHandlers } )
    },
    askAiMentor: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/aimentor/ask-mentor`, payload, { headers: headers(), ...progressHandlers } )
    },
}

api.simbaAI = {
    fetchReferenceMaterials: () => {
        return axios.get( `${baseURL}/simba-ai/reference-materials`, { headers: headers() } )
    },
    fetchPracticeSessions: () => {
        return axios.get( `${baseURL}/simba-ai/practice-sessions`, { headers: headers() } )
    },
    getUploadLink: ( payload ) => {
        return axios.post( `${baseURL}/simba-ai/get-signed-upload-url`, payload, { headers: headers() } )
    },
    addReferenceMaterial: ( payload ) => {
        return axios.post( `${baseURL}/simba-ai/add-reference-material`, payload, { headers: headers() } )
    },
    createPracticeSession: ( payload ) => {
        return axios.post( `${baseURL}/simba-ai/practice-sessions`, payload, { headers: headers() } )
    },
    fetchPracticeSessionDetails: ( practiceSessinonId ) => {
        return axios.get( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}/practice-details`, { headers: headers() } )
    },
    startNewPracticeSession: ( practiceSessinonId ) => {
        return axios.post( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}/start`, {}, { headers: headers() } )
    },
    updatePractice: ( practiceSessinonId, practiceId, payload ) => {
        return axios.patch( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}/practice/${practiceId}`, payload, { headers: headers() } )
    },
    fetchUserPracticeHistory: () => {
        return axios.get( `${baseURL}/simba-ai/practice-sessions/history`, { headers: headers() } )
    },
    fetchPracticeSession: ( practiceSessinonId ) => {
        return axios.get( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}`, { headers: headers() } )
    },
    fetchStudentPracticeSessionDetails: ( practiceSessinonId ) => {
        return axios.get( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}/attempt-details`, { headers: headers() } )
    },
    fetchLatestPracticeStreak: () => {
        return axios.get( `${baseURL}/simba-ai/practice-streak/latest`, { headers: headers() } )
    },
    updatePracticeSession: ( practiceSessinonId, payload ) => {
        return axios.put( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}`, payload, { headers: headers() } )
    },
    deletePracticeSession: ( practiceSessinonId ) => {
        return axios.delete( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}`, { headers: headers() } )
    },
    reportIssue: ( practiceSessinonId, payload ) => {
        return axios.post( `${baseURL}/simba-ai/practice-sessions/${practiceSessinonId}/report-issue`, payload, { headers: headers() } )
    },
    fetchReportedIssues: () => {
        return axios.get( `${baseURL}/simba-ai/practice-sessions/issues`, { headers: headers() } )
    },

    fetchLeaderboard: ( params = {} ) => {
        return axios.get( `${baseURL}/simba-ai/monthly-leaderboard`, { headers: headers(), params } )
    }

}

api.audit = {
    fetchUserDetails: ( auid, params = { legacy: false } ) => {
        return axios.get( `${baseURL}/audit/faculty/${auid}`, { headers: headers(), params } )
    },
    fetchInstituteDepartment: ( params, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/audit/departments`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchFacultiesUnderAuditor: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/audit/faculty`, { headers: headers(), ...progressHandlers } )
    },
    fetchSubjects: ( params ) => {
        return axios.get( `${baseURL}/audit/subjects`, { headers: headers(), params } )
    },
    impersonate: ( payload ) => {
        return axios.post( `${baseURL}/audit/impersonate`, payload, { headers: headers() } )
    },

    // USAGE
    fetchUsageStats: ( params, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/audit/usage`, { headers: headers(), ...progressHandlers, params } )
    },

    // STUDY MATERIALS
    fetchStudyMaterialStats: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/audit/stats`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchStudyMaterialCounts: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/audit/counts`, { headers: headers(), ...progressHandlers, params } )
    },
    getStudyMaterialGraph: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/audit/graph`, { headers: headers(), ...progressHandlers, params } )
    },
    getStudyMaterialsByFacultyId: ( auid, params = { legacy: false } ) => {
        return axios.get( `${studyMaterialBaseURL}/audit/faculty/${auid}`, { headers: headers(), params } )
    },
    getStudyMaterialsForAuditing: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${studyMaterialBaseURL}/audit/`, { headers: headers(), ...progressHandlers, params } )
    },

    // ASSIGNMENTS
    getAssignmentStats: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/audit/assignment/facultystats`, { headers: headers(), ...progressHandlers, params } )
    },
    getAssignmentsForAuditing: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/audit/assignment`, { headers: headers(), ...progressHandlers, params } )
    },
    getAssignmentGraph: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/audit/assignment/graph`, { headers: headers(), ...progressHandlers, params } )
    },
    getAssignmentCounts: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/audit/assignment/counts`, { headers: headers(), ...progressHandlers, params } )
    },
    getAssignmentsByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${baseURL}/audit/assignment/faculty/${auid}`, { headers: headers(), params } )
    },

    // EXAMS
    getExamsStats: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/exam/stats`, { headers: headers(), ...progressHandlers, params } )
    },
    getExamGraphData: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/exam/graph`, { headers: headers(), ...progressHandlers, params } )
    },
    getExamsCounts: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/exam/counts`, { headers: headers(), ...progressHandlers, params } )
    },
    getExamsByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${examBaseURL}/audit/exam/faculty/${auid}`, { headers: headers(), params } )
    },
    getExamsForAuditing: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/exam`, { headers: headers(), ...progressHandlers, params } )
    },

    // QUIZZES
    getQuizzesStats: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/quiz/stats`, { headers: headers(), ...progressHandlers, params } )
    },
    getQuizGraphData: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/quiz/graph`, { headers: headers(), ...progressHandlers, params } )
    },
    getQuizzesCounts: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/quiz/counts`, { headers: headers(), ...progressHandlers, params } )
    },
    getQuizzesByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${examBaseURL}/audit/quiz/faculty/${auid}`, { headers: headers(), params } )
    },
    getQuizzesForAuditing: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/quiz`, { headers: headers(), ...progressHandlers, params } )
    },

    // QUESTION BANKS
    getQuestionBanksStats: ( params = {} ) => {
        return axios.get( `${examBaseURL}/audit/questionbank/stats`, { headers: headers(), params } )
    },
    getQuestionBanksCounts: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/audit/questionbank/counts`, { headers: headers(), ...progressHandlers, params } )
    },
    getQuestionBanksByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${examBaseURL}/audit/questionbank/faculty/${auid}`, { headers: headers(), params } )
    },
    getQuestionBanksForAuditing: ( params = {} ) => {
        return axios.get( `${examBaseURL}/audit/questionbank`, { headers: headers(), params } )
    },

    // CLASS SESSIONS
    getClassSessionsCounts: ( params = {} ) => {
        return axios.get( `${classSessionApiBaseURL}/audit/counts`, { headers: headers(), params } )
    },
    getClassSessionsStats: ( params = {} ) => {
        return axios.get( `${classSessionApiBaseURL}/audit/stats`, { headers: headers(), params } )
    },
    getClassSessionsByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${classSessionApiBaseURL}/audit/faculty/${auid}`, { headers: headers(), params } )
    },
    getClassSessionsForAuditing: ( params = {} ) => {
        return axios.get( `${classSessionApiBaseURL}/audit`, { headers: headers(), params } )
    },
    getClassSessionsGraphData: ( params = {} ) => {
        return axios.get( `${classSessionApiBaseURL}/audit/graph`, { headers: headers(), params } )
    },

    // DISCUSSIONS
    getDiscussionsStats: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/audit/stats`, { headers: headers(), ...progressHandlers, params } )
    },
    getDiscussionsCounts: ( params = {}, progressHandlers = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/audit/counts`, { headers: headers(), ...progressHandlers, params } )
    },
    getDiscussionsByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${discussionForumBaseUrl}/audit/faculty/${auid}`, { headers: headers(), params } )
    },
    getDiscussionsForAuditing: ( params = {} ) => {
        return axios.get( `${discussionForumBaseUrl}/audit/`, { headers: headers(), params } )
    },

    // MEETINGS
    getMeetingsStats: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/meeting/facultystats`, { headers: headers(), params } )
    },
    getMeetingsForAuditing: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/meeting`, { headers: headers(), params } )
    },
    getMeetingsGraph: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/meeting/graph`, { headers: headers(), params } )
    },
    getMeetingsCounts: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/meeting/counts`, { headers: headers(), params } )
    },
    getMeetingsByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${baseURL}/audit/meeting/faculty/${auid}`, { headers: headers(), params } )
    },

    // Practice Sessions
    getPracticeSessionsStats: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/practice-sessions/facultystats`, { headers: headers(), params } )
    },
    getPracticeSessionsForAuditing: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/practice-sessions`, { headers: headers(), params } )
    },
    getPracticeSessionsGraph: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/practice-sessions/graph`, { headers: headers(), params } )
    },
    getPracticeSessionsCounts: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/practice-sessions/counts`, { headers: headers(), params } )
    },
    getPracticeSessionsByFacultyId: ( auid, params = { legacy: true } ) => {
        return axios.get( `${baseURL}/audit/practice-sessions/faculty/${auid}`, { headers: headers(), params } )
    },
}

api.admissionExams = {
    getUser: ( progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/user`, { headers: headers(), ...progressHandlers } )
    },
    convertDocxToHtml: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/convert-doc-to-txt`, payload, { headers: headersFormdata() } )
    },
    createExam: ( payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/admission-exams/`, payload, { headers: headersFormdata() } )
    },
    updateAdmissionExam: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/admission-exams/${id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    getAllAssessmentExams: ( params, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/`, { headers: headers(), ...progressHandlers, params } )
    },
    getExam: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchQuestionDetails: ( id, qid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/question/${qid}`, { headers: headers(), ...progressHandlers } )
    },
    getQuestionFile: ( id, fileId, responseType, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/questionfiles`, { headers: headers(), ...progressHandlers, params: { fileId }, responseType } )
    },
    updateExamQuestionOption: ( exam_id, question_id, option_id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/admission-exams/${exam_id}/question/${question_id}/option/${option_id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    removeExamQuestionOption: ( exam_id, question_id, option_id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/admission-exams/${exam_id}/question/${question_id}/option/${option_id}`, { headers: headers(), ...progressHandlers } )
    },
    updateQuestion: ( exam_id, question_id, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/admission-exams/${exam_id}/question/${question_id}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteExam: ( id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/admission-exams/${id}`, { headers: headers(), ...progressHandlers, } )
    },
    forceDeleteExam: ( id, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/admission-exams/${id}/force-delete`, { headers: headers(), ...progressHandlers, } )
    },
    fetchExamParticipation: ( id, params = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/participation`, { headers: headers(), params } )
    },
    approveExam: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/admission-exams/${id}/approve`, payload, { headers: headers(), ...progressHandlers } )
    },
    toggleClose: ( id, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/admission-exams/${id}/close`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchParticipationData: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/participation/${pid}`, { headers: headers(), ...progressHandlers } )
    },
    attempt: ( id, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/admission-exams/${id}/attempt`, {}, { headers: headers(), ...progressHandlers } )
    },
    fetchQuestions: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/questions`, { headers: headers(), ...progressHandlers } )
    },
    fetchParticipationSubmissions: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/submissions/${pid}`, { headers: headers(), ...progressHandlers } )
    },
    fetchEvaluationScheme: ( id, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/evaluationscheme`, { headers: headers(), ...progressHandlers } )
    },
    updateParticipationAttempt: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/admission-exams/${id}/participation/${pid}`, payload, { headers: headers(), ...progressHandlers } )
    },
    deleteAdmissionExamParticipation: ( id, pid, progressHandlers = {} ) => {
        return axios.delete( `${examBaseURL}/admission-exams/${id}/participation/${pid}`, { headers: headers(), ...progressHandlers } )
    },
    fetchQuestionsForAttempt: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/questions/attempt/${pid}`, { headers: headers(), ...progressHandlers } )
    },
    registerExamAttemptFault: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/admission-exams/${id}/participation/${pid}/registerfault`, payload || {}, { headers: headers(), ...progressHandlers } )
    },
    finishExam: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/admission-exams/${id}/participation/${pid}/finish`, payload || {}, { headers: headers(), ...progressHandlers } )
    },
    startExam: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.put( `${examBaseURL}/admission-exams/${id}/start/${pid}`, payload || {}, { headers: headers(), ...progressHandlers } )
    },
    submitAnswer: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/admission-exams/${id}/submissions/${pid}`, payload, { headers: headers(), ...progressHandlers } )
    },
    verifyCandidate: ( payload = {}, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/admission-exams/verify-candidate`, payload, { headers: headers(), ...progressHandlers } )
    },
    fetchParticipationQuestions: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/participation/${pid}/questions`, { headers: headers(), ...progressHandlers } )
    },
    uploadWorkSheet: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/admission-exams/${id}/${pid}/upload-worksheet`, payload, { headers: headersFormdata() } )
    },
    assignMarksToDescriptiveAnswer: ( id, pid, payload, progressHandlers = {} ) => {
        return axios.post( `${examBaseURL}/exams/${id}/submission/${pid}/assignmarks`, payload, { headers: headers(), ...progressHandlers } )
    },
    getWorksheetUrl: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/${pid}/get-worksheet`, { headers: headers(), ...progressHandlers } )
    },
    fetchCandidateParticipation: ( id, pid, progressHandlers = {} ) => {
        return axios.get( `${examBaseURL}/admission-exams/${id}/participation/${pid}`, { headers: headers(), ...progressHandlers } )
    }
}

api.announcements = {
    fetchAnnouncements: ( params, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/announcement`, { headers: headers(), ...progressHandlers, params } )
    },
    fetchAnnouncement: ( announcement_id, progressHandlers = {} ) => {
        return axios.get( `${baseURL}/announcement/${announcement_id}`, { headers: headers(), ...progressHandlers } )
    },
    fetchAnnouncementAttachment: ( announcement_id, payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/announcement/${announcement_id}/attachment`, payload, { headers: headers(), ...progressHandlers } )
    },
    createAnnouncement: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/announcement`, payload, { headers: headersFormdata() } )
    },
    updateAnnouncement: ( announcement_id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/announcement/${announcement_id}`, payload, { headers: headersFormdata() } )
    },
    deleteAnnouncement: ( announcement_id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/announcement/${announcement_id}`, { headers: headers(), ...progressHandlers } )
    },
    removeAttachment: ( announcement_id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/announcement/${announcement_id}/attachment`, payload, { headers: headers(), ...progressHandlers } )
    },
    addAttachments: ( announcement_id, payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/announcement/${announcement_id}/addattachment`, payload, { headers: headersFormdata() } )
    }
}

api.logging = {
    fetchServiceLogs: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/debug-logs`, { headers: headers(), params } )
    },
    fetchServiceLogsStats: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/debug-logs/stats`, { headers: headers(), params } )
    },
    filterUsers: ( params = {} ) => {
        return axios.get( `${baseURL}/audit/filter-users`, { headers: headers(), params } )
    },
    fetchAdminActivityLogs: ( params = {} ) => {
        return axios.get( `${baseURL}/admin-activity`, { headers: headers(), params } )
    }
}

api.onlineMeetings = {
    createMeeting: ( payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting`, payload, { headers: headers() } )
    },
    fetchMeetings: () => {
        return axios.get( `${meetingsBaseURL}/meeting`, { headers: headers() } )
    },
    endMeeting: ( meetingId ) => {
        return axios.delete( `${meetingsBaseURL}/meeting/${meetingId}/end`, { headers: headers() } )
    },
    fetchClassMeeting: ( timeTableId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/class/${timeTableId}`, { headers: headers() } )
    },
    checkConflictingClassSession: ( timeTableId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/class/${timeTableId}/check-conflict`, { headers: headers() } )
    },
    checkRoomAccessPermissions: ( meetingId ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/check-permissions`, {}, { headers: headers( true ) } )
    },
    fetchMeeting: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}`, { headers: headers() } )
    },
    fetchMeetingAccessGroupsAndUsers: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/access-list`, { headers: headers() } )
    },
    updateMeetingAccess: ( meetingId, payload ) => {
        return axios.put( `${meetingsBaseURL}/meeting/${meetingId}/access-list`, payload, { headers: headers() } )
    },
    updateMeetingDetails: ( meetingId, payload ) => {
        return axios.put( `${meetingsBaseURL}/meeting/${meetingId}`, payload, { headers: headers() } )
    },
    updateMeetingSettings: ( meetingId, payload ) => {
        return axios.put( `${meetingsBaseURL}/meeting/${meetingId}/settings`, payload, { headers: headers() } )
    },
    fetchMeetingAttendance: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/attendance`, { headers: headers() } )
    },
    fetchMeetingChatsAndPoll: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/get-chats-and-polls`, { headers: headers() } )
    },
    getMeetingAccessToken: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/get-meeting-access-token`, payload, { headers: headers() } )
    },
    fetchGuestUser: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/${meetingId}/get-guest-user`, payload )
    },
    deleteMeeting: ( meetingId ) => {
        return axios.delete( `${meetingsBaseURL}/meeting/${meetingId}`, { headers: headers() } )
    },
    verifyRecorderToken: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/verify-recorder-token`, payload, { headers: headers() } )
    },
    submitFeedback: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/feedback`, payload, { headers: headers() } )
    },
    fetchMeetingFeedbacks: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/feedback`, { headers: headers() } )
    },

    fetchMeetingPresentations: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/presentation-file`, { headers: headers() } )
    },
    uploadMeetingPresentations: ( meetingId, payload, progressHandler ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/presentation-file`, payload, { headers: headersFormdata(), onUploadProgress: progressHandler } )
    },
    fetchPresentationFileDetails: ( meetingId, fileId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/presentation-file/${fileId}`, { headers: headers() } )
    },
    getPresentationFileUploadStatus: ( meetingId, fileId, jobId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/presentation-file/${fileId}/status/${jobId}`, { headers: headers() } )
    },
    deletePresentationFile: ( meetingId, fileId ) => {
        return axios.delete( `${meetingsBaseURL}/meeting/${meetingId}/presentation-file/${fileId}`, { headers: headers() } )
    },
    getHybridClassVideoFileUploadSignedUrl: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/get-signedurl-for-video-upload`, payload, { headers: headers() } )
    },
    addHybridClassVideoFileDetails: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/video-details-upload`, payload, { headers: headers() } )
    },
    updateHybridClassVideoWatchProgress: ( meetingId, videoId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/video/${videoId}/progress`, payload, { headers: headers() } )
    },
    deleteHybridClassVideo: ( meetingId, videoId ) => {
        return axios.delete( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/video/${videoId}`, { headers: headers() } )
    },
    extendHybridClassVideoTime: ( meetingId, payload ) => {
        return axios.patch( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/accept-time-extionsion-requests`, payload, { headers: headers() } )
    },
    fetchMeetingVideoProgresses: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/video-progress`, { headers: headers() } )
    },
    requestHybridClassAccessTimeExtension: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/access-time-extension-request`, payload, { headers: headers() } )
    },
    fetchHybridClassAccessTimeExtensionRequests: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/access-time-extension-request`, { headers: headers() } )
    },
    pushAttendanceToERP: ( meetingId ) => {
        return axios.post( `${meetingsBaseURL}/attendance/class/${meetingId}`, {}, { headers: headers() } )
    },

    // Hybrid class video repository uploads (Uppy + S3 multipart, backed by a Redis upload session)
    createHybridClassVideoUpload: ( payload ) => {
        return axios.post( `${baseURL}/hybrid-class-video`, payload, { headers: headers() } )
    },
    signHybridClassVideoUpload: ( payload ) => {
        return axios.post( `${baseURL}/hybrid-class-video/uploads/sign`, payload, { headers: headers() } )
    },
    finalizeHybridClassVideoUpload: ( payload ) => {
        return axios.post( `${baseURL}/hybrid-class-video/finish`, payload, { headers: headers() } )
    },
    discardHybridClassVideoUpload: ( payload ) => {
        return axios.post( `${baseURL}/hybrid-class-video/uploads/discard`, payload, { headers: headers() } )
    },

    fetchHybridClassVideos: ( params = {} ) => {
        return axios.get( `${baseURL}/hybrid-class-video`, { headers: headers(), params } )
    },
    fetchRecordingSubjects: () => {
        return axios.get( `${baseURL}/hybrid-class-video/subjects`, { headers: headers() } )
    },
    deleteHybridClassRecording: ( id ) => {
        return axios.delete( `${baseURL}/hybrid-class-video/${id}`, { headers: headers() } )
    },
    updateHybridClassVideo: ( recordingId, payload ) => {
        return axios.patch( `${baseURL}/hybrid-class-video/${recordingId}`, payload, { headers: headers() } )
    },
    fetchHybridClassRecordingDetails: ( id ) => {
        return axios.get( `${baseURL}/hybrid-class-video/${id}`, { headers: headers() } )
    },

    // Faculty
    assignHybridClassVideoToClass: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/assign-recording`, payload, { headers: headers() } )
    },
    fetchHybridClassVideoAssignments: () => {
        return axios.get( `${meetingsBaseURL}/hybrid-class-video/assignments`, { headers: headers() } )
    },
    removeRecordingAssignmentFromClass: ( assignmentId ) => {
        return axios.delete( `${meetingsBaseURL}/hybrid-class-video/assignments/${assignmentId}`, { headers: headers() } )
    },
    fetchRecordingAssignmentsDetails: ( recordingId ) => {
        return axios.get( `${meetingsBaseURL}/hybrid-class-video/${recordingId}/assignments`, { headers: headers() } )
    }

}

api.recording = {
    createRecording: ( meetingId ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/record/accquire`, {}, { headers: headers() } )
    },
    startRecording: ( meetingId, recordingId, payload ) => {
        console.log( meetingId, recordingId, payload )

        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/record/start/${recordingId}`, payload, { headers: headers() } )
    },
    stopRecording: ( meetingId, recordingId ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/record/stop/${recordingId}`, {}, { headers: headers() } )
    },
    fetchMeetingRecordings: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/recordings`, { headers: headers() } )
    },
    fetchMeetingRecordingSignedUrl: ( meetingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/recordings`, payload, { headers: headers() } )
    },
    fetchHybridClassRecordings: ( meetingId ) => {
        return axios.get( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/recordings`, { headers: headers() } )
    },
    fetchHybridClassRecordingSignedUrl: ( meetingId, recordingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/recordings/${recordingId}`, payload, { headers: headers() } )
    },
    startWatchingHybridClassRecording: ( meetingId, recordingId, payload ) => {
        return axios.post( `${meetingsBaseURL}/meeting/${meetingId}/hybrid-class/recordings/${recordingId}`, payload, { headers: headers() } )
    }
}

api.tutorialsAndManuals = {
    getTutorials: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/tutorial`, { headers: headers(), ...progressHandlers } )
    },
    addTutorial: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/tutorial`, payload, { headers: headersFormdata(), ...progressHandlers } )
    },

    updateTutorial: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/tutorial/${id}`, payload, { headers: headersFormdata(), ...progressHandlers } )
    },

    deleteTutorial: ( id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/tutorial/${id}`, { headers: headers(), ...progressHandlers } )
    },
    getManuals: ( progressHandlers = {} ) => {
        return axios.get( `${baseURL}/manual`, { headers: headers(), ...progressHandlers } )
    },

    addManual: ( payload, progressHandlers = {} ) => {
        return axios.post( `${baseURL}/manual`, payload, { headers: headersFormdata(), ...progressHandlers } )
    },

    updateManual: ( id, payload, progressHandlers = {} ) => {
        return axios.put( `${baseURL}/manual/${id}`, payload, { headers: headersFormdata(), ...progressHandlers } )
    },
    deleteManual: ( id, progressHandlers = {} ) => {
        return axios.delete( `${baseURL}/manual/${id}`, { headers: headers(), ...progressHandlers } )
    },

}

export default api